// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Obc_","placeholdersHeader":"styles_placeholdersHeader__31cZZ","editorStyle":"styles_editorStyle__1kKG1","placeholdersBox":"styles_placeholdersBox__1C_Qc"};